export class NotAuthenticatedException extends Error {
  constructor(message?: string) {
    super(message)

    Object.setPrototypeOf(this, NotAuthenticatedException.prototype)
  }
}

export default NotAuthenticatedException
